import { DomainModelHelper } from '@digital-platform/shared/domain';
import { Hazmat } from '../interfaces';

export class HazmatModel implements Hazmat {
  constructor(config: Hazmat) {
    this.id = config
      ? DomainModelHelper.ensureDataIsString(config.id)
      : HazmatModel.DEFAULT_CONFIG.id;
    this.symbols = config
      ? DomainModelHelper.ensureDataIsStringArray(config.symbols)
      : HazmatModel.DEFAULT_CONFIG.symbols;
    this.properShippingName = config
      ? DomainModelHelper.ensureDataIsString(config.properShippingName)
      : HazmatModel.DEFAULT_CONFIG.properShippingName;
    this.hazardousClass = config
      ? DomainModelHelper.ensureDataIsString(config.hazardousClass)
      : HazmatModel.DEFAULT_CONFIG.hazardousClass;
    this.unOrNaNumber = config
      ? DomainModelHelper.ensureDataIsString(config.unOrNaNumber)
      : HazmatModel.DEFAULT_CONFIG.unOrNaNumber;
    this.labelCodes = config
      ? DomainModelHelper.ensureDataIsStringArray(config.labelCodes)
      : HazmatModel.DEFAULT_CONFIG.labelCodes;
    this.specialProvisions = config
      ? DomainModelHelper.ensureDataIsStringArray(config.specialProvisions)
      : HazmatModel.DEFAULT_CONFIG.specialProvisions;
    this.packagingExceptions = config
      ? DomainModelHelper.ensureDataIsString(config.packagingExceptions)
      : HazmatModel.DEFAULT_CONFIG.packagingExceptions;
    this.packagingNonBulk = config
      ? DomainModelHelper.ensureDataIsString(config.packagingNonBulk)
      : HazmatModel.DEFAULT_CONFIG.packagingNonBulk;
    this.packagingBulk = config
      ? DomainModelHelper.ensureDataIsString(config.packagingBulk)
      : HazmatModel.DEFAULT_CONFIG.packagingBulk;
    this.quantityLimitPassengerAircraftOrRail = config
      ? DomainModelHelper.ensureDataIsString(
          config.quantityLimitPassengerAircraftOrRail
        )
      : HazmatModel.DEFAULT_CONFIG.quantityLimitPassengerAircraftOrRail;
    this.quantityLimitCargoAircraft = config
      ? DomainModelHelper.ensureDataIsString(config.quantityLimitCargoAircraft)
      : HazmatModel.DEFAULT_CONFIG.quantityLimitCargoAircraft;
    this.vesselStowageLocation = config
      ? DomainModelHelper.ensureDataIsString(config.vesselStowageLocation)
      : HazmatModel.DEFAULT_CONFIG.vesselStowageLocation;
    this.vesselStowageOtherProvisions = config
      ? DomainModelHelper.ensureDataIsStringArray(
          config.vesselStowageOtherProvisions
        )
      : HazmatModel.DEFAULT_CONFIG.vesselStowageOtherProvisions;

    switch (config.packagingGroup) {
      case 'I':
        this.packagingGroup = 'I';
        break;
      case 'II':
        this.packagingGroup = 'II';
        break;
      case 'III':
        this.packagingGroup = 'III';
        break;
      default:
        this.packagingGroup = HazmatModel.DEFAULT_CONFIG.packagingGroup;
    }
  }

  public static DEFAULT_CONFIG: Hazmat = {
    id: null,
    symbols: [],
    properShippingName: null,
    hazardousClass: null,
    unOrNaNumber: null,
    packagingGroup: null,
    labelCodes: [],
    specialProvisions: [],
    packagingExceptions: null,
    packagingNonBulk: null,
    packagingBulk: null,
    quantityLimitPassengerAircraftOrRail: null,
    quantityLimitCargoAircraft: null,
    vesselStowageLocation: null,
    vesselStowageOtherProvisions: []
  };

  readonly id: string;
  readonly symbols: string[];
  readonly properShippingName: string;
  readonly hazardousClass: string;
  readonly unOrNaNumber: string;
  readonly packagingGroup: 'I' | 'II' | 'III';
  readonly labelCodes: string[];
  readonly specialProvisions: string[];
  readonly packagingExceptions: string;
  readonly packagingNonBulk: string;
  readonly packagingBulk: string;
  readonly quantityLimitPassengerAircraftOrRail: string;
  readonly quantityLimitCargoAircraft: string;
  readonly vesselStowageLocation: string;
  readonly vesselStowageOtherProvisions: string[];
}
